{
  "clear": "Очистить",
  "invalid": "(недействительно)",
  "loading": "Загрузка...",
  "noResults": "Результаты отсутствуют",
  "valid": "(действительный)"
}
